import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useFetch } from 'use-http';
import graph3 from 'assets/icons/graphs/graph3.svg';
import { apiBridges } from 'constants/api';
import { STRUCTURES_PATHS } from 'constants/paths';
import { useGlobalSelector } from 'stores';
import { inspectionTabMapping } from 'utils/inspectionTabMapping';
import { handleDynamicInspectionsTabChange } from 'utils/utilities';
import { flattenOverviewL3, L3RecapContent } from './L3RecapContent';

// Sotto-tab "Riepilogo" di L3 (form attività in corso di compilazione).
// 2026-08-18 — non legge più dal form RHF live (watch()): chiama la stessa
// GET bridges/:id/overview/L3 usata dal gemello TabL3.jsx (Dettaglio
// Ponte), passando esplicitamente l'inspectionId dell'attività aperta.
// Mostra quindi l'ultimo stato SALVATO dell'attività, non le modifiche non
// ancora salvate nel form — scelta esplicita, vedi commento in testa a
// L3RecapContent.jsx.
//
// Issue #1021, punto 16 — carosello immagini aggiunto qui il 2026-09-01,
// stesso pattern di TabL1.jsx (il sotto-tab "Riepilogo" di L1 riusa TabL1.jsx
// stesso, che fa già questo fetch; L3 ha un componente Recap separato — vedi
// commento sopra — quindi il fetch va replicato qui esplicitamente).
//
// makeApprofondisci verso l'attività CORRENTE (structureId/inspectionId di
// useParams, non un "ultima attività valida" come in TabL3.jsx): qui
// un'attività L3 è sempre in corso (è la ragione per cui questo componente
// è montato), quindi approfondisciDisabled è sempre false — a differenza di
// TabL1.jsx riusato nel proprio sotto-tab Riepilogo (dove `structure` non è
// passato e i bottoni restano sempre disabilitati), L3 può risolvere
// l'inspectionId localmente e i bottoni funzionano davvero.
const imagesWeb = [
  { original: graph3, originalHeight: '130px' },
  { original: graph3, originalHeight: '130px' },
  { original: graph3, originalHeight: '130px' },
  { original: graph3, originalHeight: '130px' },
  { original: graph3, originalHeight: '130px' },
  { original: graph3, originalHeight: '130px' },
];

const renderVideo = item => (
  <div>
    <video controls style={{ width: '400px', height: '130px' }}>
      <source src={item.original}></source>
    </video>
  </div>
);

const L3Recap = () => {
  const { structureId, inspectionId } = useParams();
  const { get } = useFetch();
  const { showLoader, hideLoader } = useGlobalSelector();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [overviewL3, setOverviewL3] = useState();
  const [imagesList, setImagesList] = useState();

  useEffect(() => {
    const getOverviewL3 = async () => {
      try {
        showLoader();
        const result = await get(
          `${apiBridges.ROOT}/${structureId}/overview/L3?inspectionId=${inspectionId}`
        );
        result && setOverviewL3(result);
      } catch (err) {
        console.error('Error in get L3 Recap: ', err);
        enqueueSnackbar(
          `Si è verificato un errore nella lettura del riepilogo L3`,
          { variant: 'error' }
        );
      } finally {
        hideLoader();
      }
    };

    const getImages = async () => {
      const resultMedia = await get(
        `${apiBridges.ROOT}/${structureId}/overviewImages?level=L3`
      );
      if (resultMedia?.length > 0) {
        setImagesList(
          resultMedia.map(x => ({
            original: x.url,
            originalHeight: '130px',
            renderItem: x.isVideo ? renderVideo : null,
          }))
        );
      }
    };

    if (structureId && inspectionId) {
      getOverviewL3();
      getImages();
    }
  }, [structureId, inspectionId]);

  if (!overviewL3) return null;

  return (
    <L3RecapContent
      values={flattenOverviewL3(overviewL3)}
      imagesList={imagesList}
      imagesFallback={imagesWeb}
      makeApprofondisci={accordion => () =>
        handleDynamicInspectionsTabChange(
          inspectionTabMapping.L3,
          inspectionTabMapping.DatiGenerali,
          accordion,
          navigate,
          STRUCTURES_PATHS.STRUCTURES_LIST,
          structureId,
          inspectionId
        )}
      approfondisciDisabled={false}
    />
  );
};

export { L3Recap };
